import { v4 as uuidv4 } from 'uuid';

export const NOTIFICATION_LOGOUT_EVENT = 'bw:notification-logout-start';
export const NOTIFICATION_LOGOUT_CANCELLED_EVENT = 'bw:notification-logout-cancelled';
export const NOTIFICATION_DEVICE_STORAGE_KEY = 'baochau.portal.notification-device';
export const NOTIFICATION_PUSH_STORAGE_KEY = 'baochau.portal.notification-push';

export const getNotificationDeviceId = () => {
  let id = window.localStorage.getItem(NOTIFICATION_DEVICE_STORAGE_KEY);
  if (!id) {
    id = uuidv4();
    window.localStorage.setItem(NOTIFICATION_DEVICE_STORAGE_KEY, id);
  }
  return id;
};

export const canUseBrowserPush = () => typeof window !== 'undefined' && window.isSecureContext
  && 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;

export const prepareBrowserPush = async (config, onMessage) => {
  const [appSdk, messagingSdk] = await Promise.all([import('firebase/app'), import('firebase/messaging')]);
  if (!(await messagingSdk.isSupported())) throw new Error('Trình duyệt này chưa hỗ trợ thông báo.');
  const appName = `bao-chau-notifications-${config.firebase_config.projectId}`;
  const app = appSdk.getApps().find(item => item.name === appName) || appSdk.initializeApp(config.firebase_config, appName);
  const messaging = messagingSdk.getMessaging(app);
  const publicPath = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const appBase = process.env.REACT_APP_BASENAME ?? publicPath;
  const registration = await navigator.serviceWorker.register(
    `${publicPath}/firebase-messaging-sw.js?config=${encodeURIComponent(JSON.stringify(config.firebase_config))}&app_base=${encodeURIComponent(appBase)}`,
  );
  const token = await messagingSdk.getToken(messaging, { vapidKey: config.vapid_key, serviceWorkerRegistration: registration });
  if (!token) throw new Error('Chưa đăng ký được thông báo. Vui lòng thử lại.');
  return { token, unsubscribe: messagingSdk.onMessage(messaging, onMessage) };
};
